import React from 'react';
import { Calendar, MapPin, Clock, IndianRupee } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import PaymentButton from './PaymentButton';

const PackageCard = ({ package: pkg, className = '' }) => {
  const navigate = useNavigate();

  const handleBookNow = () => {
    // Store selected package in localStorage for booking
    localStorage.setItem('selectedPackage', JSON.stringify(pkg));
    navigate('/contact');
  };

  const handlePaymentSuccess = (response) => {
    console.log('Payment successful:', response);
    navigate('/contact', { state: { paymentSuccess: true, paymentId: response.razorpay_payment_id } });
  };

  return (
    <div 
      className={`group relative bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:scale-105 ${className}`}
      style={{ minWidth: '280px' }}
    >
      {/* Image */}
      <div className="relative h-56 overflow-hidden">
        <img 
          src={pkg.image} 
          alt={pkg.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        
        {/* Badge for Backpacking trips */}
        {pkg.type === 'backpacking' && (
          <div className="absolute top-4 right-4 bg-red-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
            Every Saturday
          </div>
        )}
        
        {/* Price Badge */}
        <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-lg">
          <div className="flex items-center gap-1">
            <IndianRupee size={18} className="text-red-600" />
            <span className="text-xl font-bold text-gray-900">{pkg.price.toLocaleString()}</span>
            <span className="text-sm text-gray-600">/person</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-1">
          {pkg.name}
        </h3>

        <div className="space-y-2 mb-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Clock size={16} className="text-blue-600" />
            <span>{pkg.duration}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <MapPin size={16} className="text-blue-600" />
            <span>{pkg.departure}</span>
          </div>
          {pkg.availableDates && (
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <Calendar size={16} className="text-blue-600" />
              <span>{pkg.availableDates}</span>
            </div>
          )}
        </div>

        {/* Highlights */}
        {pkg.highlights && pkg.highlights.length > 0 && (
          <div className="mb-4">
            <div className="flex flex-wrap gap-2">
              {pkg.highlights.slice(0, 3).map((highlight, index) => (
                <span 
                  key={index}
                  className="text-xs bg-blue-50 text-blue-700 px-2 py-1 rounded-full"
                >
                  {highlight}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Buttons */}
        <div className="space-y-2">
          <Button 
            onClick={handleBookNow}
            className="w-full bg-gradient-to-r from-red-600 to-blue-600 hover:from-red-700 hover:to-blue-700 text-white transition-all duration-300 hover:scale-105"
          >
            Book Now
          </Button>
          
          <PaymentButton 
            packageData={pkg} 
            onSuccess={handlePaymentSuccess}
          />
        </div>
      </div>
    </div>
  );
};

export default PackageCard;